import React, { useState, useEffect } from 'react';
import { useMutation } from "react-query";
import { Button } from '@mui/material';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import apiClient from "../../request/http-common";
import Card from '@mui/material/Card';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useNavigate } from 'react-router-dom';
import WithdrawalFormFields from './WithdrawalFormFields';
import useWithdrawalCoinOptions from '../../hooks/useWithdrawalCoinOptions';

const WithdrawalButton = () => {
    const navigate = useNavigate();
    const { estimateCoinDeduction, formatUsd, formatCryptoAmount, getCoinUnits, getCoinUsd } = useWithdrawalCoinOptions();

    const [error, setErros] = useState('');
    const [amount, setAmount] = useState('');
    const [coinName, setCoinName] = useState('');
    const [address, setAddress] = useState('');
    const [destinationTag, setDestinationTag] = useState('');

    const [barstate, setBarState] = useState({ bottom: false });

    const usdAmount = parseFloat(amount) || 0;
    const { coinAmount: coinToDeduct } = estimateCoinDeduction(coinName, usdAmount);
    const availableUnits = coinName ? getCoinUnits(coinName) : 0;
    const availableUsd = coinName ? getCoinUsd(coinName) : 0;

    const toggleDrawer = (open) => () => {
        setBarState({ bottom: open });
    };

    useEffect(() => {
        const handler = () => setBarState({ bottom: true });
        window.addEventListener('toggleWithdrawalBar', handler, false);
        return () => window.removeEventListener('toggleWithdrawalBar', handler);
    }, []);

    const { isLoading: isWithdrawing, mutate: postWithdrawal } = useMutation(
        async () => {
          const payload = {
            amount: usdAmount,
            coin_name: coinName,
            address: address,
          };
          if (coinName === 'XRP' && destinationTag.trim()) {
            payload.destination_tag = destinationTag.trim();
          }
          return await apiClient.post(`/api/withdraw`, payload);
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
                localStorage.setItem('notification', JSON.stringify({ message: res.data.message, type: 'success' }));
                window.dispatchEvent(new Event('newMessage'));
                setBarState({ bottom: false });
              }
          },
          onError: (err) => {
                const errorMessage = err.response?.data?.message || err.message || 'Withdrawal failed';
                localStorage.setItem('notification', JSON.stringify({ message: errorMessage, type: 'error' }));
                window.dispatchEvent(new Event('newMessage'));
          },
        }
      );

    const handleWithdraw = () => {
      if (!coinName || usdAmount < 1 || !address?.trim()) return;
      if (coinToDeduct > availableUnits) {
        localStorage.setItem('notification', JSON.stringify({
          message: `Insufficient ${coinName} balance`,
          type: 'error',
        }));
        window.dispatchEvent(new Event('newMessage'));
        return;
      }
      postWithdrawal();
    };

  return (
    <div>
        <Button onClick={() => navigate('/send-coin')} variant="contained" color='secondary' startIcon={<MoneyOffIcon />}>
            Withdraw
        </Button>

      <SwipeableDrawer
      anchor="bottom"
      open={barstate.bottom}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      > 
      <Card sx={{ borderRadius: '9px', height: '100%'}}>
      <Typography my={3} px={4} sx={{textAlign: 'center'}} variant="body2" color="secondary">
      Fill the form below to withdraw your funds
      </Typography>
          <CardContent>
            <WithdrawalFormFields
              amount={amount}
              setAmount={setAmount}
              coinName={coinName}
              setCoinName={setCoinName}
              address={address}
              setAddress={setAddress}
              destinationTag={destinationTag}
              setDestinationTag={setDestinationTag}
              error={error}
            />
        </CardContent>
          <CardActions>
          <Button onClick={handleWithdraw} fullWidth size="large" color="primary" variant="contained">
            {isWithdrawing ? 'Processing...' : 'Withdraw'}
          </Button>
          </CardActions>
        </Card>
    </SwipeableDrawer>
    </div>
  )
}

export default WithdrawalButton
